import { API_URL } from "env";
import { uploadMediaImage } from "./Media";

async function getUserInfo(): Promise<any> {
    try {
        const response = await fetch(API_URL + '/api/v1/fe/customer/profile', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
        });

        if (!response.ok) {
            if (response.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                console.warn('Unauthorized access - perhaps the user is not logged in.');
                return null;
            }
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data.data || null;
    } catch (error) {
        console.error('Failed to fetch user info:', error);
        return null;
    }
}
interface UpdateInterface {
    fullname?: string,
    phone?: string,
    dob?: string,
    avatar?: File,
    // Business info
    business_name?: string,
    business_type?: string,
    business_province?: string,
    business_district?: string,
    business_ward?: string,
    business_address?: string,
    //Business License
    business_license_number?: string,
    business_license_date?: string,
    business_license_place?: string,
    business_image?: File,
    // Pharmacy License
    pharmacy_license_number?: string,
    pharmacy_license_date?: string,
    pharmacy_license_place?: string,
    pharmacy_license_image?: File,
    // GPP
    gpp_number?: string,
    gpp_date?: string,
    gpp_expired_date?: string,
    // gpp_place?: string,
    gpp_image?: File,
    // Bank info
    bank_name?: string,
    bank_number?: string,
    bank_account?: string,
}

async function updateUserInfo(updateData: UpdateInterface): Promise<void> {
    try {
        let avatarPath = "";
        if (updateData.avatar && updateData.avatar instanceof File) {
            const uploadRes = await uploadMediaImage(updateData.avatar);
            if (uploadRes && uploadRes.status) {
                avatarPath = uploadRes.data.image;
            }
        }
        let businessImagePath = "";
        if (updateData.business_image && updateData.business_image instanceof File) {
            const uploadRes = await uploadMediaImage(updateData.business_image);
            if (uploadRes && uploadRes.status) {
                businessImagePath = uploadRes.data.image;
            }
        }

        let pharmacyLicenseImagePath = "";
        if (updateData.pharmacy_license_image instanceof File) {
            const uploadRes = await uploadMediaImage(updateData.pharmacy_license_image);

            if (uploadRes?.status) {
                pharmacyLicenseImagePath = uploadRes.data.image;
            }
        }

        let gppImagePath = "";
        if (updateData.gpp_image instanceof File) {
            const uploadRes = await uploadMediaImage(updateData.gpp_image);

            if (uploadRes?.status) {
                gppImagePath = uploadRes.data.image;
            }
        }

        const body = new URLSearchParams();
        if (updateData.fullname) body.append('fullname', updateData.fullname);
        if (updateData.phone) body.append('phone', updateData.phone);
        if (updateData.dob) body.append('birthday', updateData.dob);
        if (avatarPath) body.append('avatar', avatarPath);

        if (updateData.business_name) body.append('business_name', updateData.business_name);
        if (updateData.business_type) body.append('business_type', updateData.business_type);
        // 1
        if (updateData.business_license_number) body.append('business_license_number', updateData.business_license_number);
        if (updateData.business_license_date) body.append('business_license_date', updateData.business_license_date);
        if (updateData.business_license_place) body.append('business_license_place', updateData.business_license_place);
        if (businessImagePath) body.append('business_image', businessImagePath);
        // Pharmacy License
        if (updateData.pharmacy_license_number)
            body.append("pharmacy_license_number", updateData.pharmacy_license_number);

        if (updateData.pharmacy_license_date)
            body.append("pharmacy_license_date", updateData.pharmacy_license_date);

        if (updateData.pharmacy_license_place)
            body.append("pharmacy_license_place", updateData.pharmacy_license_place);

        if (pharmacyLicenseImagePath)
            body.append("pharmacy_license_image", pharmacyLicenseImagePath);

        // GPP
        if (updateData.gpp_number)
            body.append("gpp_number", updateData.gpp_number);

        if (updateData.gpp_date)
            body.append("gpp_date", updateData.gpp_date);

        if (updateData.gpp_expired_date)
            body.append("gpp_expired_date", updateData.gpp_expired_date);

        if (gppImagePath)
            body.append("gpp_image", gppImagePath);
        
        if (updateData.business_province) body.append('business_province', updateData.business_province);
        if (updateData.business_district) body.append('business_district', updateData.business_district);
        if (updateData.business_ward) body.append('business_ward', updateData.business_ward);
        if (updateData.business_address) body.append('business_address', updateData.business_address);
        if (updateData.bank_name) body.append('bank_name', updateData.bank_name);
        if (updateData.bank_number) body.append('bank_number', updateData.bank_number);
        if (updateData.bank_account) body.append('bank_account', updateData.bank_account);

        const response = await fetch(API_URL + '/api/v1/fe/customer/update', {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: body.toString(),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    } catch (error) {
        console.error('Failed to update user info:', error);
    }
}

async function changePassword(currentPassword: string, newPassword: string, confirm_password: string): Promise<void> {
    try {
        const data = new FormData();
        data.append('old_password', currentPassword);
        data.append('new_password', newPassword);
        data.append('confirm_password', confirm_password);
        const response = await fetch(API_URL + '/api/v1/fe/customer/update_password', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: data,
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        console.log('Password changed successfully');
    } catch (error) {
        console.error('Failed to change password:', error);
    }
}

export { getUserInfo, updateUserInfo, changePassword, updateAffiliate };

interface UpdateAffiliateResponse {
    status: boolean;
    msg?: string;
    error?: Record<string, string>;
}

async function updateAffiliate(affiliate_sale: string): Promise<UpdateAffiliateResponse> {
    try {
        const response = await fetch(API_URL + '/api/v1/fe/customer/update_affiliate', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: JSON.stringify({ affiliate_sale }),
        });

        const responseData = await response.json();
        if (!responseData.status && responseData.error) {
            const firstError = Object.values(responseData.error)[0] as string;
            return { status: false, msg: firstError, error: responseData.error };
        }
        return responseData as UpdateAffiliateResponse;
    } catch (error) {
        console.error('Failed to update affiliate:', error);
        return { status: false, msg: 'Cập nhật mã giới thiệu thất bại' };
    }
}